import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import heroImg from "../assests/images/hero.jpg";
import { FaHeart, FaRegHeart, FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function HotelSearch() {
    const [hotels, setHotels] = useState([]);
    const location = useLocation();
    const searchData = location.state;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [wishlist, setWishlist] = useState([]);

    // Load wishlist
    useEffect(() => {
        const storedWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        setWishlist(storedWishlist);
    }, []);

    // Save wishlist
    const updateWishlist = (updated) => {
        setWishlist(updated);
        localStorage.setItem("wishlist", JSON.stringify(updated));
    };

    // Toggle wishlist
    const toggleWishlist = (hotel) => {
        const isLoggedIn = true;

        if (!isLoggedIn) {
            alert("Please login to add to wishlist");
            return;
        }

        const exists = wishlist.find(item => item.id === hotel.id);

        let updated;
        if (exists) {
            updated = wishlist.filter(item => item.id !== hotel.id);
        } else {
            updated = [...wishlist, hotel];
        }

        updateWishlist(updated);
    };

    const isWishlisted = (id) => {
        return wishlist.some(item => item.id === id);
    };

    // Fetch hotels
    useEffect(() => {
        const fetchHotels = async () => {
            setLoading(true);
            setError(false);

            try {
                const res = await axios.get("https://beachhotelsdubai.com/api/hotels", {
                    params: {
                        destination: searchData?.destination
                    }
                });

                setHotels(res.data);
            } catch (err) {
                console.error(err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchHotels();
    }, [searchData]);

    return (
        <div>


            <Hero
                heightClass="sm:h-[230px] md:h-[250px] lg:h-[200px]"
                title="Search Results"
                backgroundImage={heroImg}
            />

            <div className="p-6 max-w-screen-2xl mx-auto">
                <h1 className="text-2xl font-bold mb-6">Search Results</h1>

                {loading ? (
                    <div className="flex flex-col justify-center items-center py-20 gap-4">
                        <div className="animate-spin rounded-full h-12 w-12 border-4 border-teal-500 border-t-transparent"></div>
                        <p className="text-gray-500">Searching hotels...</p>
                    </div>

                ) : error ? (
                    <div className="text-center py-20">
                        <p className="text-red-500 text-lg">Something went wrong</p>
                    </div>

                ) : hotels.length > 0 ? (
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {hotels.map((hotel) => (
                            <div
                                key={hotel.id}
                                onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                className="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                            >
                                {/* Image Section */}
                                <div
                                    className="relative h-56 w-full overflow-hidden cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(`/hotels/${hotel.slug}`);
                                    }}
                                >
                                    <img
                                        src={`https://beachhotelsdubai.com/uploads/hotels/${hotel.image}`}
                                        alt={hotel.name}
                                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                    />

                                    {/* Overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

                                    {/* Wishlist Icon */}
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleWishlist(hotel);
                                        }}
                                        className="absolute top-3 right-3 bg-white/90 p-2 rounded-full shadow hover:scale-110 transition"
                                    >
                                        {isWishlisted(hotel.id) ? (
                                            <FaHeart className="text-red-500" />
                                        ) : (
                                            <FaRegHeart className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Rating Badge */}
                                    <div className="absolute top-3 left-3 bg-white/90 text-gray-800 px-3 py-1 rounded-full text-sm font-semibold shadow flex items-center gap-1">
                                        ⭐ 4.5
                                        <span className="text-yellow-600 text-xs font-medium">
                                            Excellent (120)
                                        </span>
                                    </div>

                                    {/* Price Badge */}
                                    <div className="absolute bottom-3 right-3 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-bold shadow">
                                        {Math.round(hotel.price_per_night)} AED / night
                                    </div>
                                </div>

                                {/* Content */}
                                <div className="p-5">
                                    <h3
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/hotels/${hotel.slug}`);
                                        }}
                                        className="text-xl font-semibold text-gray-800 group-hover:text-teal-600 transition cursor-pointer hover:underline"
                                    >
                                        {hotel.name}
                                    </h3>

                                    <p className="text-sm text-gray-500 mt-1 flex items-center gap-1">
                                        <FaMapMarkerAlt className="text-blue-900" />
                                        Jumeirah Lakes Towers Dubai, United Arab Emirates
                                    </p>

                                    {/* Divider line */}
                                    <div className="border-t my-3"></div>

                                    {/* <p className="text-sm text-gray-600 line-clamp-2">
                                        {hotel.description}
                                    </p> */}

                                    <p className="text-slate-600 text-sm mt-4 leading-6 line-clamp-2 min-h-[48px]">
                                        {hotel.short_description?.replace(/<[^>]*>/g, "")}
                                    </p>

                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/hotels/${hotel.slug}`);
                                        }}
                                        className="mt-5 w-full bg-gradient-to-r from-[#0F172A] to-[#FF8C42] text-white py-2 rounded-lg font-medium hover:from-teal-600 hover:to-blue-600 transition cursor-pointer"
                                    >
                                        View Details
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-gray-500 py-20">
                        No hotels found
                    </p>
                )}
            </div>


        </div>
    );
}